import { Text, View, Image, ScrollView } from 'react-native';

import React from 'react';
import { promoStyles } from '../styles/promo';

export const Promo = () => {
  return (
    <>
      <Text style={promoStyles.title}>Promo</Text>
      <ScrollView horizontal showsHorizontalScrollIndicator={false}>
        <View style={promoStyles.promoWrapper}>
          <View style={promoStyles.promoCopy}>
            <Text style={promoStyles.promoText}>
              Snacks time <br></br>made better
            </Text>
            <Text style={promoStyles.promoText2}>~20% OFF~</Text>
          </View>
          <Image
            source={require('../../assets/burger2.png')}
            style={promoStyles.promoPic}
          />
        </View>
        <View style={promoStyles.promoWrapper2}>
          <View style={promoStyles.promoCopy}>
            <Text style={promoStyles.promoText}>
              Fruity & tasty <br></br>dessert
            </Text>
            <Text style={promoStyles.promoText2}>~10% OFF~</Text>
          </View>
          <Image
            source={require('../../assets/vanilla.png')}
            style={promoStyles.promoPic}
          />
        </View>
      </ScrollView>
    </>
  );
};
